import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: window.config.google.key,
        libraries: 'places'
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/maps.js